import React from 'react';
import './FaceSwapHowTo.css';

const FaceSwapHowTo: React.FC = () => {
  const steps = [
    {
      id: 1,
      title: "Upload your original file",
      description: "Upload an image or video containing the faces you want to replace. Drag-and-drop is supported."
    },
    {
      id: 2,
      title: "Select faces and upload targets",
      description: "For multiple face swap: Select detected faces and click the target placeholders to upload replacement faces. For single face swap: Upload your target face image."
    },
    {
      id: 3,
      title: "Start the face swap",
      description: `Click "Start Face Swap" and wait for AI processing. Download your result when complete.`
    }
  ];

  return (
    <section className="face-swap-howto">
      <div className="howto-wrapper">
        <h2 className="howto-main-title">How to Swap Faces in 3 Simple Steps</h2>
        
        <div className="howto-content">
          <div className="howto-illustration">
            <div className="illustration-placeholder">
              <div className="illustration-badge">
                <span>4K</span>
              </div>
            </div>
          </div>
          
          <div className="howto-steps">
            {steps.map((step) => (
              <div key={step.id} className="step-item">
                <div className="step-badge">
                  <span>{step.id}</span>
                </div>
                <div className="step-content">
                  <h3 className="step-title">{step.title}</h3>
                  <p className="step-description">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaceSwapHowTo;